import {HStack, Text, VStack} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

import {RadioButtonGroup} from '../../components/RadioButtonGroup/RadioButtonGroup';

interface ChoiceChipsProps extends TestIdProps {
  label: string;
  choices: number[];
  value: number;
  formatValue: (value: number) => string;
  onChange: (value: number) => void;
}

/** Every click reaches `onChange`, the selected chip too, so a rebased choice can be confirmed. */
export function ChoiceChips(props: ChoiceChipsProps) {
  return (
    <VStack spacing={2} data-testid={suffixTestId('choice', props)}>
      <HStack justify="space-between" align="baseline" spacing={3}>
        <span data-testid={suffixTestId('label', props)}>
          <Text size="base" color="secondary">
            {props.label}
          </Text>
        </span>
        <span data-testid={suffixTestId('value', props)}>
          <Text size="base" alternative>
            {props.formatValue(props.value)}
          </Text>
        </span>
      </HStack>
      <RadioButtonGroup<number>
        appearance="compact"
        label={props.label}
        value={props.value}
        options={props.choices.map((choice) => ({value: choice, label: choice.toString()}))}
        onChange={props.onChange}
        data-testid={props['data-testid']}
      />
    </VStack>
  );
}
